import React, { useEffect, useState, useRef } from 'react';
import erpHeroBackground from '../../Assets/Images/Careers/5061807.jpg';
import erpDashboardImage from '../../Assets/Images/LifeAtGS/visit4.jpg';
import { Link } from 'react-router-dom';
import bgImage from '../../Assets/Images/CaseStudy/honeyc.jpg';
import mobilefriendly from '../../Assets/Images/service/mobile-access.png';
import cloud from '../../Assets/Images/service/cloud.png';
import dashboardicon from '../../Assets/Images/service/dashboardIcon.png';
import module from '../../Assets/Images/service/module.png';
import roleMange from '../../Assets/Images/service/roleManage.png';
import support from '../../Assets/Images/service/support.png';
import "../../Assets/CSS/Styles.scss";
import { Button } from 'react-bootstrap';
const Services = () => {

  const [inView, setInView] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          // Optional: stop observing after first trigger
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.1, // Trigger when 10% of element is visible
      }
    );

    const currentSection = sectionRef.current; // ✅ store ref value once

    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) {
        observer.unobserve(currentSection); // ✅ cleanup uses the same element
      }
    };
  }, []);

  const carouselSlides = [
    {
      image: erpDashboardImage,
      school: "AISSMS Institute of Information Technology, Pune, Maharashtra",
      description: " We had the pleasure of welcoming faculty from AISSMS Institute of Information Technology, Pune, for an engaging discussion on internships and career opportunities at Global Solutions. This collaboration aims to provide BTech students with real-world exposure, guided by the vision of our CEO, Mr. Sagar Shete, and our dedicated team.",
      facebookLink: "https://www.facebook.com/share/19aSHZHEYb/",
      // result: "Reduced administrative time by 60%"
    }

  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => {
    setCurrentSlide((prevSlide) =>
      prevSlide === carouselSlides.length - 1 ? 0 : prevSlide + 1
    );
  };

  const prevSlide = () => {
    setCurrentSlide((prevSlide) =>
      prevSlide === 0 ? carouselSlides.length - 1 : prevSlide - 1
    );
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const slide = carouselSlides[currentSlide]; // Get the current slide data
  return (
    <div className='service-Container mt60' >
      {/* Hero Section */}
      <section
        className="relative h-[500px] md:h-[488px] flex items-center justify-center p-2 overflow-hidden py-10 bg-gray-50"
      >
        <div
          className="absolute inset-0 bg-center bg-cover animate-slowZoom"
          style={{ backgroundImage: `url(${erpHeroBackground})` }} // Use the imported image
        ></div>
        {/* Overlay for darkening the image */}
        <div className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-[3px] z-1"></div>

        {/* Content */}
        <div className="relative z-10 text-white text-left max-w-4xl mx-auto px-4 md:px-0 md:ml-12 lg:ml-24">
          {/* Small "Professional Development Services" text */}
          <div className="flex justify-center md:justify-start">
            <div className="inline-flex items-center px-5 py-2 mb-8 text-sm font-medium text-black bg-[#ffdd9d] rounded-full">
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
              </svg>
              Professional Development Services
            </div>
          </div>

          {/* Main Heading */}
          <h1 className="font-heading font-bold-500 text-white text-2xl md:text-4xl lg:text-5xl text-center md:text-left mb-4">
            Custom <span className="font-heading font-bold-500  inline-block text-[#FBBF24]">ERP</span> Development
          </h1>

          {/* Subheading/Description */}
          <p className="font-ui text-white text-md leading-6 mt-6 mb-8 p">
            Our ERP Development service empowers your institution with the <br className="hidden md:inline" /> clarity and tools it needs to streamline operations and drive growth.
          </p>

          {/* Book Free Consultation Button */}
          <div className="flex justify-center md:justify-start">

            <Button
              as={Link}
              to="/freedemo"
              className="text-[14px] demo-button bg-[#F59E0B]  hover:bg-[#f3b541] font-bold font-ui flex items-center gap-2"
            >
              Book Free Consultations

            </Button>

          </div>
        </div>
      </section>

      {/* What This Service Covers Section */}
      <section className="relative py-16 bg-gray-50"> {/* Changed to solid bg for mobile */}
        {/* Background - Only shown on desktop */}
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat z-0"
          style={{
            backgroundImage: `url(${bgImage})`,
            maskImage: 'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
            WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
          }}>
          <div className="absolute inset-0 bg-white/80 bg-opacity-80"></div>
        </div>

        <div className="relative z-10 container mx-auto px-4 sm:px-6 max-w-7xl">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="font-heading mb-3 text-[25px] font-bold color: #111827 text-gray-900">
              What This Service Covers
            </h2>
            <p className="text-sm md:text-base text-gray-600 font-ui max-w-2xl mx-auto">
              Comprehensive solutions designed to address every aspect of your institutional needs
            </p>

          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Feature Card 1 - Custom Module Creation */}
            <div className="bg-white rounded-xl shadow-md p-6 cardborder relative transition-all duration-300 hover:scale-105 hover:shadow-lg ">
              <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-16 h-16 bg-amber-100 text-amber-500 rounded-full flex items-center justify-center border-2 border-white">
                {/* Puzzle Icon */}
                <img src={module} alt="Custom module icon" className="w-9 h-9 object-contain"></img>
              </div>
              <h3 className="text-center text-[#111827] font-heading text-[20px] font-bold mt-6">
                Custom Module Creation
              </h3>
              <p className="text-center text-[15px] text-[#374151] font-ui mt-2 leading-relaxed">
                Tailored modules built to meet your organization’s specific needs.
              </p>
            </div>

            {/* Feature Card 2 - Hybrid Cloud Support */}
            <div className="bg-white rounded-xl shadow-md p-6 cardborder relative transition-all duration-300 hover:scale-105 hover:shadow-lg ">
              <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-16 h-16 bg-amber-100 text-amber-500 rounded-full flex items-center justify-center border-2 border-white">
                {/* Cloud Icon */}
                <img src={cloud} alt="Custom module icon" className="w-9 h-9 object-contain"></img>
              </div>
              <h3 className="text-center text-[#111827] font-heading text-[20px] font-bold mt-6">
                Hybrid Cloud Support
              </h3>
              <p className="text-center text-[15px] text-[#374151] font-ui mt-2 leading-relaxed">
                Supports both on-premise and multi-cloud environments.
              </p>
            </div>

            {/* Feature Card 3 - Data & Role Management */}
            <div className="bg-white rounded-xl shadow-md p-6 cardborder relative transition-all duration-300 hover:scale-105 hover:shadow-lg ">
              <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-16 h-16 bg-amber-100 text-amber-500 rounded-full flex items-center justify-center border-2 border-white">
                {/* role  */}
                <img src={roleMange} alt="Custom module icon" className="w-9 h-9 object-contain"></img>
              </div>
              <h3 className="text-center text-[#111827] font-heading text-[20px] font-bold mt-6">
                Data & Role Management
              </h3>
              <p className="text-center text-[15px] text-[#374151] font-ui mt-2 leading-relaxed">
                Seamless integration with full control over user roles and access.
              </p>
            </div>

            {/* Feature Card 4 - Real-time Dashboards */}
            <div className="bg-white rounded-xl shadow-md p-6 cardborder relative transition-all duration-300 hover:scale-105 hover:shadow-lg ">
              <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-16 h-16 bg-amber-100 text-amber-500 rounded-full flex items-center justify-center border-2 border-white">
                {/* dashboard Icon */}
                <img src={dashboardicon} alt="Custom module icon" className="w-9 h-9 object-contain"></img>
              </div>
              <h3 className="text-center text-[#111827] font-heading text-[20px] font-bold mt-6">
                Real-time Dashboards
              </h3>
              <p className="text-center text-[15px] text-[#374151] font-ui mt-2 leading-relaxed">
                Get powerful insights through visualized data and live stats.
              </p>
            </div>

            {/* Feature Card 5 - Mobile-Friendly Design */}
            <div className="bg-white rounded-xl shadow-md p-6 cardborder relative transition-all duration-300 hover:scale-105 hover:shadow-lg ">
              <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-16 h-16 bg-amber-100 text-amber-500 rounded-full flex items-center justify-center border-2 border-white">
                {/* smartphoen Icon */}
                <img src={mobilefriendly} alt="Custom module icon" className="w-9 h-9 object-contain"></img>
              </div>
              <h3 className="text-center text-[#111827] font-heading text-[20px] font-bold mt-6">
                Mobile-Friendly Design
              </h3>
              <p className="text-center text-[15px] text-[#374151] font-ui mt-2 leading-relaxed">
                Interface designed to work seamlessly across all device types.
              </p>
            </div>

            {/* Feature Card 6 - Expert Tooling & Support */}
            <div className="bg-white rounded-xl shadow-md p-6 cardborder relative transition-all duration-300 hover:scale-105 hover:shadow-lg ">
              <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-16 h-16 bg-amber-100 text-amber-500 rounded-full flex items-center justify-center border-2 border-white">
                {/* support Icon */}
                <img src={support} alt="Custom module icon" className="w-9 h-9 object-contain"></img>
              </div>
              <h3 className="text-center text-[#111827] font-heading text-[20px] font-bold mt-6">
                Expert Tooling & Support
              </h3>
              <p className="text-center text-[15px] text-[#374151] font-ui mt-2 leading-relaxed">
                Get help from professionals and make the most of our advanced tools.
              </p>
            </div>
          </div>

        </div>
      </section>

      {/* Who It's For Section */}

      <section className="relative py-8 md:py-16 bg-gray-50">
        {/* Background - Only shown on desktop */}
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat z-0"
          style={{
            backgroundImage: `url(${bgImage})`,
            maskImage: 'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
            WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
          }}>
          <div className="absolute inset-0 bg-white/80 bg-opacity-80"></div>
        </div>

        <div className="relative z-10 container mx-auto px-4 sm:px-6 max-w-6xl">
          <div className="text-center mb-6 md:mb-12">
            <h2 className="font-heading mb-3 text-xl md:text-[25px] font-bold text-gray-900">
              Who It's For
            </h2>
            <p className="text-xs md:text-base text-gray-600 font-ui max-w-2xl mx-auto">
              Perfect for organizations looking to modernize and streamline their operations
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-6 animate-slowZoom justify-items-center">
            {/* Card 1: Educational Institutions */}
            <div className="bg-white p-3 md:p-6 border-2 border-[#F59E0B] rounded-lg shadow-md flex flex-col items-center text-center w-full max-w-[140px] md:max-w-[180px] h-full">
              <div className="w-10 h-10 md:w-16 md:h-16 bg-[#d3ccf5] rounded-full flex items-center justify-center mb-2 md:mb-3">
                <svg className="w-5 h-5 md:w-8 md:h-8 text-[#5B42F3]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2-.895-2-2-2zm0-4V7a1 1 0 00-1-1H9a1 1 0 00-1 1v3m4 0h2a1 1 0 001-1V7a1 1 0 00-1-1h-2a1 1 0 00-1 1v3zm-4 0v3a1 1 0 001 1h2a1 1 0 001-1V9M5 5a2 2 0 012-2h10a2 2 0 012 2v14a2 2 0 01-2 2H7a2 2 0 01-2-2V5z" />
                </svg>
              </div>
              <p className="text-[10px] md:text-sm text-gray-800 font-semibold font-ui leading-tight">Educational Institutions</p>
            </div>

            {/* Card 2: Startups and SMEs */}
            <div className="bg-white p-3 md:p-6 rounded-lg border-2 border-[#F59E0B] shadow-md flex flex-col items-center text-center w-full max-w-[140px] md:max-w-[180px] h-full">
              <div className="w-10 h-10 md:w-16 md:h-16 bg-[#d3ccf5] rounded-full flex items-center justify-center mb-2 md:mb-3">
                <svg className="w-5 h-5 md:w-8 md:h-8 text-[#5B42F3]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <p className="text-[10px] md:text-sm text-gray-800 font-semibold font-ui leading-tight">Startups and SMEs</p>
            </div>

            {/* Card 3: Nonprofits */}
            <div className="bg-white p-3 md:p-6 rounded-lg border-2 border-[#F59E0B] shadow-md flex flex-col items-center text-center w-full max-w-[140px] md:max-w-[180px] h-full">
              <div className="w-10 h-10 md:w-16 md:h-16 bg-[#d3ccf5] rounded-full flex items-center justify-center mb-2 md:mb-3">
                <svg className="w-5 h-5 md:w-8 md:h-8 text-[#5B42F3]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </div>
              <p className="text-[10px] md:text-sm text-gray-800 font-semibold font-ui leading-tight">Nonprofits</p>
            </div>

            {/* Card 4: Enterprises */}
            <div className="bg-white p-3 md:p-6 rounded-lg border-2 border-[#F59E0B] shadow-md flex flex-col items-center text-center w-full max-w-[140px] md:max-w-[180px] h-full">
              <div className="w-10 h-10 md:w-16 md:h-16 bg-[#d3ccf5] rounded-full flex items-center justify-center mb-2 md:mb-3">
                <svg className="w-5 h-5 md:w-8 md:h-8 text-[#5B42F3]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1M9 11h1M9 15h1m10-4h-1m1 4h-1m-9-4h4m-7 4h7m-9 0V9a2 2 0 012-2h2a2 2 0 012 2v7" />
                </svg>
              </div>
              <p className="text-[10px] md:text-sm text-gray-800 font-semibold font-ui leading-tight">Enterprises</p>
            </div>

            {/* Card 5: Multi-campus Networks */}
            <div className="bg-white p-3 md:p-6 rounded-lg border-2 border-[#F59E0B] shadow-md flex flex-col items-center text-center w-full max-w-[140px] md:max-w-[180px] h-full">
              <div className="w-10 h-10 md:w-16 md:h-16 bg-[#d3ccf5] rounded-full flex items-center justify-center mb-2 md:mb-3">
                <svg className="w-5 h-5 md:w-8 md:h-8 text-[#5B42F3]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h2a2 2 0 002-2V7a2 2 0 00-2-2h-3M9 20H7a2 2 0 01-2-2V7a2 2 0 012-2h3m0 13v-9a2 2 0 012-2h2a2 2 0 012 2v9m-10 0h10" />
                </svg>
              </div>
              <p className="text-[10px] md:text-sm text-gray-800 font-semibold font-ui leading-tight">Multi-campus Networks</p>
            </div>
          </div>
        </div>
      </section>

      {/* Why It Matters Section */}
      <section className="relative py-16 bg-gray-50"> {/* Changed to solid bg for mobile */}
        {/* Background - Only shown on desktop */}
         <div className="absolute inset-0 bg-cover bg-center bg-no-repeat z-0"
          style={{
            backgroundImage: `url(${bgImage})`,
            maskImage: 'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
            WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
          }}>
          <div className="absolute inset-0 bg-white/80 bg-opacity-80"></div>
        </div>

        <div className="relative z-10 container mx-auto px-4 sm:px-6 max-w-7xl">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="font-heading mb-3  text-[25px] font-bold text-gray-900">
              Why It Matters
            </h2>
            <p className="text-sm md:text-base text-gray-600 font-ui max-w-2xl mx-auto">
              Transform your institution with measurable business value and operational excellence
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4  gap-6">
            {/* Card 1: Streamline Operations */}
            <div className="bg-[#FFF8F4] p-6 rounded-lg shadow-md flex flex-col items-start text-left transition-all duration-300 hover:scale-105 hover:shadow-lg">
              <div className="w-12 h-12 bg-[#d3ccf5] rounded-full flex items-center justify-center mb-4 ">
                <svg className="w-6 h-6 text-[#5B42F3]  " fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </div>
              <h3 className="text-[20px]font-heading font-bold text-[#111827] mb-2">Streamline Operations</h3>
              <p className=" text-[15px] mb-5 color: #374151 font-ui text-base leading-relaxed">Reduce manual work by 70% with automated workflows</p>
            </div>

            {/* Card 2: Enhanced Security */}
            <div className="bg-[#FFF8F4] p-6 rounded-lg shadow-md flex flex-col items-start text-left transition-all duration-300 hover:scale-105 hover:shadow-lg">
              <div className="w-12 h-12 bg-[#d3ccf5] rounded-full flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-[#5B42F3]  " fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.01 12.01 0 002 12c0 2.514.809 4.815 2.182 6.79M12 21h9M3 10h18" />
                </svg>
              </div>
              <h3 className="text-[20px]font-heading font-bold text-[#111827] mb-2">Enhanced Security</h3>
              <p className=" text-[15px] mb-5 color: #374151 font-ui text-base leading-relaxed">Bank-level security with role-based access controls</p>
            </div>

            {/* Card 3: Data-Driven Decisions */}
            <div className="bg-[#FFF8F4] p-6 rounded-lg shadow-md flex flex-col items-start text-left transition-all duration-300 hover:scale-105 hover:shadow-lg">
              <div className="w-12 h-12 bg-[#d3ccf5] rounded-full flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-[#5B42F3] " fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.75 17L9 20l-1 1h4c-.722-.534-1.29-1.077-1.638-1.579C12.394 15.632 13 14 13 14s.693-1.632 1.638-1.579c.348.502.916 1.045 1.638 1.579L16 20l-1 1h4M5 7l.463-.095A2 2 0 006.309 5.378L10 2l-2 4h4.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-[20px]font-heading font-bold text-[#111827] mb-2">Data-Driven Decisions</h3>
              <p className=" text-[15px] mb-5 color: #374151 font-ui text-base leading-relaxed">Real-time insights to improve institutional performance</p>
            </div>

            {/* Card 4: Scalable Growth */}
            <div className="bg-[#FFF8F4] p-6 rounded-lg shadow-md flex flex-col items-start text-left transition-all duration-300 hover:scale-105 hover:shadow-lg">
              <div className="w-12 h-12 bg-[#d3ccf5] rounded-full flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-[#5B42F3] " fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-[20px]font-heading font-bold text-[#111827] mb-2">Scalable Growth</h3>
              <p className=" text-[15px] mb-5 color: #374151 font-ui text-base leading-relaxed">Platform grows with your institution's expanding needs</p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Process Section */}
      <section className="relative py-16 bg-gray-50" ref={sectionRef}>
        {/* Background - Only shown on desktop */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat z-0"
          style={{
            backgroundImage: `url(${bgImage})`,
            maskImage: 'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
            WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
          }}>
          <div className="absolute inset-0 bg-white/80 bg-opacity-80"></div>
        </div>

        <div className="relative z-10 container mx-auto px-4 sm:px-6 max-w-7xl overflow-hidden">

          <div className="text-center mb-8 md:mb-12">
            <h2 className="font-heading mb-3 text-[25px] font-bold text-gray-900">
              Our Process
            </h2>
            <p className="text-sm md:text-base text-gray-600 font-ui max-w-2xl mx-auto">
              A proven methodology that ensures successful project delivery every time
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 relative  mb-1 ">
            {/* Process Card 1 */}
            <div className={inView ? 'animate-slide-in-1' : 'opacity-0'}>
              <div className="bg-white p-6 border-l-4 border-[#F59E0B] rounded-lg shadow-md flex items-start space-x-4">
                <div className="flex-shrink-0 text-white w-10 h-10 bg-[#FFA500] rounded-full flex items-center justify-center text-lg font-bold">01</div>
                <div>
                  <h3 className="text-[20px] font-heading font-bold text-[#111827] mb-2">Discovery & Consultation</h3>
                  <p className="text-[15px] mb-5 text-[#374151] leading-relaxed">We analyze your current systems and understand your specific requirements</p>
                </div>
              </div>
            </div>

            {/* Process Card 2 */}
            <div className={inView ? 'animate-slide-in-2' : 'opacity-0'}>
              <div className="bg-white p-6 border-l-4 border-[#F59E0B] rounded-lg shadow-md flex items-start space-x-4">
                <div className="flex-shrink-0 text-white w-10 h-10 bg-[#FFA500] rounded-full flex items-center justify-center text-lg font-bold">02</div>
                <div>
                  <h3 className="text-[20px] font-heading font-bold text-[#111827] mb-2">Planning & Architecture</h3>
                  <p className="text-[15px] mb-5 text-[#374151] leading-relaxed">Design the system architecture and create detailed project roadmap</p>
                </div>
              </div>
            </div>

            {/* Process Card 3 */}
            <div className={inView ? 'animate-slide-in-3' : 'opacity-0'}>
              <div className="bg-white p-6 border-l-4 border-[#F59E0B] rounded-lg shadow-md flex items-start space-x-4">
                <div className="flex-shrink-0 text-white w-10 h-10 bg-[#FFA500] rounded-full flex items-center justify-center text-lg font-bold">03</div>
                <div>
                  <h3 className="text-[20px] font-heading font-bold text-[#111827] mb-2">Development & Integration</h3>
                  <p className="text-[15px] mb-5 text-[#374151] leading-relaxed">Build custom modules and integrate with your existing systems</p>
                </div>
              </div>
            </div>

            {/* Process Card 4 */}
            <div className={inView ? 'animate-slide-in-4' : 'opacity-0'}>
              <div className="bg-white p-6 border-l-4 border-[#F59E0B] rounded-lg shadow-md flex items-start space-x-4">
                <div className="flex-shrink-0 text-white w-10 h-10 bg-[#FFA500] rounded-full flex items-center justify-center text-lg font-bold">04</div>
                <div>
                  <h3 className="text-[20px] font-heading font-bold text-[#111827] mb-2">Testing & Quality Assurance</h3>
                  <p className="text-[15px] mb-5 text-[#374151] leading-relaxed">Rigorous testing to ensure reliability and performance</p>
                </div>
              </div>
            </div>

            {/* Process Card 5 */}
            <div className={inView ? 'animate-slide-in-5' : 'opacity-0'}>
              <div className="bg-white p-6 border-l-4 border-[#F59E0B] rounded-lg shadow-md flex items-start space-x-4">
                <div className="flex-shrink-0 text-white w-10 h-10 bg-[#FFA500] rounded-full flex items-center justify-center text-lg font-bold">05</div>
                <div>
                  <h3 className="text-[20px] font-heading font-bold text-[#111827] mb-2">Deployment & Training</h3>
                  <p className="text-[15px] mb-5 text-[#374151] leading-relaxed">Smooth launch with comprehensive staff training and support</p>
                </div>
              </div>
            </div>

            {/* Process Card 6 */}
            <div className={inView ? 'animate-slide-in-6' : 'opacity-0'}>
              <div className="bg-white p-6 border-l-4 border-[#F59E0B] rounded-lg shadow-md flex items-start space-x-4">
                <div className="flex-shrink-0 text-white w-10 h-10 bg-[#FFA500] rounded-full flex items-center justify-center text-lg font-bold">06</div>
                <div>
                  <h3 className="text-[20px] font-heading font-bold text-[#111827] mb-2">Ongoing Support</h3>
                  <p className="text-[15px] mb-5 text-[#374151] leading-relaxed">Continuous maintenance, updates, and technical assistance</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Work in Action Section (with basic carousel functionality) */}

      <section className="relative py-16 bg-gray-50"> {/* Changed to solid bg for mobile */}
        {/* Background - Only shown on desktop */}
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat z-0"
          style={{
            backgroundImage: `url(${bgImage})`,
            maskImage: 'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
            WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
          }}>
          <div className="absolute inset-0 bg-white/80 bg-opacity-80"></div>
        </div>
        <div className="relative z-10 container mx-auto px-4 sm:px-6 max-w-7xl">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="font-heading mb-3 text-[25px] font-bold text-gray-900">
              College Visits & Opportunities
            </h2>
            <p className="text-sm md:text-base text-gray-600 font-ui max-w-2xl mx-auto">
              Building strong connections with colleges to bridge the gap between education and industry through visits, internships, and placements. </p>
          </div>




          <div className="relative flex items-center justify-center p-4 bg-white rounded-xl shadow-lg border border-gray-200">
            {/* Left Arrow */}
            <button
              onClick={prevSlide}
              className="absolute left-4 p-2 font-ui rounded-full bg-gray-100 shadow-md text-gray-700 hover:bg-gray-200 focus:outline-none z-20"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7"></path>
              </svg>
            </button>

            {/* Content for the current slide */}
            <div className="flex flex-col lg:flex-row items-center gap-8 p-6 transition-opacity duration-500 ease-in-out opacity-100">
              <div className="flex-shrink-0 w-full font-ui lg:w-1/2">
                <img src={slide.image} alt={slide.school} className="rounded-lg shadow-xl" />
              </div>
              <div className="flex-grow text-center lg:text-left w-full lg:w-1/2">
                <h3 className="text-[#111827] font-heading font-bold mb-4 text-[35px]">{slide.school}</h3>
                <p className="text-[15px] mb-2 text-[#374151] font-ui">
                  {slide.description}{" "}
                  <a
                    href={slide.facebookLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline hover:text-blue-800"
                  >
                    View on Facebook
                  </a>
                </p>

                <div className="mb-6">
                  {/* <span className="text-[15px] mb-2 font-ui text-[#111827]">Result:</span> */}
                  {/* <div className="inline-block bg-[#D1FAE5] text-[#047857] px-3 py-1 ml-2 rounded-full text-sm font-medium">
                    {slide.result}
                  </div> */}
                </div>
                <Link to='/freedemo' ><button className="bg-blue-900 font-ui text-white px-6 py-3 rounded-lg font-semibold flex items-center justify-center w-full lg:inline-flex hover:bg-[#4a35cb] transition-colors gap-2">
                  Want To Join Us
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
                  </svg>
                </button></Link>
              </div>
            </div>

            {/* Right Arrow */}
            <button
              onClick={nextSlide}
              className="absolute right-4 p-2 rounded-full bg-gray-100 shadow-md text-gray-700 hover:bg-gray-200 focus:outline-none z-20"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
              </svg>
            </button>

            {/* Pagination dots */}
            <div className="absolute bottom-4 flex space-x-2 z-20">
              {carouselSlides.map((_, index) => (
                <span
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`w-2 h-2 rounded-full cursor-pointer ${currentSlide === index ? 'bg-[#5B42F3]' : 'bg-gray-300'}`}
                ></span>
              ))}
            </div>
          </div>
        </div>
      </section>
      {/* Let's Bring Your Vision to Life Section */}
      <section className="bg-blue-900 text-white mt-4 py-16">
        <div className="vision-container mx-auto text-center px-6 max-w-4xl">
          <h2 className="font-heading font-bold mb-4 text-[35px]  ">Let's Bring Your Vision to Life</h2>
          <p className=" text-[18px] font-ui mb-8">Ready to transform your institution? Let's discuss your project requirements</p>

          <div className="cta-wrapper">
            <Button
              as={Link}
              to="/freedemo"
              className="text-[14px] demo-button bg-[#F59E0B]  hover:bg-[#f3b541] font-bold font-ui flex items-center gap-2"
            >
              Book 15-min Discovery Call
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </Button>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Services;
